import { useEffect } from 'react';
import Hero from './Hero';
import QuickServices from './QuickServices';
import WhyElhamyLabs from './WhyElhamyLabs';
import Statistics from './Statistics';
import AppPromo from './AppPromo';
import Testimonials from './Testimonials';
import Partners from './Partners';
import VisitorCounter from '@/components/VisitorCounter';

const Home = () => {
  useEffect(() => {
    document.title = 'ElhamyLabs - Medical Laboratory';
  }, []);

  return (
    <div className="home-page">
      <Hero />
      <QuickServices />
      <WhyElhamyLabs />
      <Statistics />
      <AppPromo />
      <Testimonials />
      <Partners />
      <VisitorCounter />
    </div>
  );
};

export default Home;

